import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { publicApi } from '../api/client';

const DEFAULTS = {
  site_title: 'Randevu',
  brand_name: 'Cəbrayıl Abbasov',
  chat_title: 'Randevu Dəstək',
  chat_welcome: 'Salam! Sizə necə kömək edə bilərəm?',
  footer_text: 'Cəbrayıl Abbasov — Bütün hüquqlar qorunur.',
  hero_person_image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf',
  page_title: 'Dr. Cəbrayıl Abbasov',
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const loadSettings = useCallback(async () => {
    try {
      console.log('Loading settings from:', `${process.env.REACT_APP_BACKEND_URL}/api/public/settings`);
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/settings`);
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      }
      const data = await res.json();
      console.log('Settings loaded from API:', data);
      if (data && typeof data === 'object') {
        const newSettings = { ...DEFAULTS, ...data };
        console.log('Merged settings:', newSettings);
        setSettings(newSettings);
        if (data.page_title) document.title = data.page_title;
      }
    } catch (error) {
      console.error('Failed to load settings:', error);
      // Keep defaults on error
    } finally {
      setLoading(false);
    }
  }, []);

  const refresh = useCallback(async () => {
    console.log('Refreshing settings...');
    await loadSettings();
  }, [loadSettings]);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (alive) {
        await loadSettings();
      }
    })();
    return () => { alive = false; };
  }, [loadSettings]);

  return (
    <SettingsContext.Provider value={{ settings, refresh, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
